import { ShareFat } from '@phosphor-icons/react';
import { useLazyCreateMessageSharedLinkQuery } from 'src/store/services/sharingApi';
import { useGetUser, useVisible } from 'src/hooks';
import { ShareModal } from './components/ShareModal';
import { sendGTMEvent } from 'src/utils';
import { GTMEvent } from 'src/types';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { PlacesType } from 'react-tooltip';
import { useChatHistory } from 'src/hooks';

type ShareButtonProps = {
  messageId?: string | null;
  disabled?: boolean;
  withTitle?: boolean;
  withTooltip?: boolean;
  tooltipPlace?: PlacesType;
};

export const ShareButton = ({
  messageId,
  disabled,
  withTitle,
  tooltipPlace = 'left',
  withTooltip = true,
}: ShareButtonProps) => {
  const { isNinjaRetired } = useChatHistory();
  const { isVisible, onVisibilityRemove, onVisibilitySet } = useVisible();

  const { user_id } = useGetUser();
  const [
    createMessageLink,
    { data: shareMessageLink, isLoading: isMessageLinkLoading },
  ] = useLazyCreateMessageSharedLinkQuery();

  const handleClose = () => {
    onVisibilityRemove();
  };

  const handleShareButtonClick = async () => {
    sendGTMEvent(GTMEvent.SHARE_BUTTON);
    onVisibilitySet();

    if (messageId) {
      return await createMessageLink({
        userId: user_id,
        messageId: messageId,
      });
    }
  };

  if (isNinjaRetired) {
    return null;
  }

  return (
    <>
      <Button
        type="button"
        disabled={disabled || isMessageLinkLoading}
        onClick={handleShareButtonClick}
        data-e2e="share-button"
        size={withTitle ? 'medium' : 'small'}
        shape={withTitle ? 'regular' : 'round'}
        color={withTitle ? 'secondary-outline' : 'transparent'}
        tooltipContent={withTooltip ? 'Share' : undefined}
        tooltipPlace={withTooltip ? tooltipPlace : undefined}
      >
        <ShareFat size={SVG_SIZE_M} />
        {withTitle && 'Share'}
      </Button>

      <ShareModal
        isOpen={isVisible}
        isLoading={isMessageLinkLoading}
        shareLink={shareMessageLink}
        onClose={handleClose}
      />
    </>
  );
};
